var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-dialog",
    {
      attrs: { "max-width": "700" },
      model: {
        value: _vm.isVisible,
        callback: function ($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "scanner-upload-card" },
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.$t("dialog.title")))]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.formValid,
                    callback: function ($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid",
                  },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-n10" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              items: _vm.placeOptions,
                              label: _vm.$t("dialog.place_name"),
                              rules: _vm.validationRules.placeName,
                              disabled: !!_vm.place,
                              required: "",
                            },
                            model: {
                              value: _vm.placeNameModel,
                              callback: function ($$v) {
                                _vm.placeNameModel = $$v
                              },
                              expression: "placeNameModel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mb-n5" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              items: _vm.trapOptions,
                              label: _vm.$t("dialog.trap_no"),
                              rules: _vm.validationRules.trapNo,
                              required: "",
                              "data-testid": "scanner_trap_no",
                            },
                            model: {
                              value: _vm.formData.trapNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "trapNo", $$v)
                              },
                              expression: "formData.trapNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mb-n5" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("date-picker-dropdown", {
                            attrs: {
                              type: "date",
                              "date-picker-props": {
                                "data-testid": "scanner_install_picker",
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  var displayValue = ref.displayValue
                                  return [
                                    _c(
                                      "text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              value: displayValue,
                                              label: _vm.$t(
                                                "dialog.install_date"
                                              ),
                                              rules:
                                                _vm.validationRules.installDate,
                                              required: "",
                                              readonly: "",
                                              "data-testid":
                                                "scanner_install_date",
                                            },
                                          },
                                          "text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.formData.installDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "installDate", $$v)
                              },
                              expression: "formData.installDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("date-picker-dropdown", {
                            attrs: {
                              type: "date",
                              "date-picker-props": {
                                "data-testid": "scanner_collect_picker",
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  var displayValue = ref.displayValue
                                  return [
                                    _c(
                                      "text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              value: displayValue,
                                              label: _vm.$t(
                                                "dialog.collect_date"
                                              ),
                                              rules:
                                                _vm.validationRules.collectDate,
                                              required: "",
                                              readonly: "",
                                              "data-testid":
                                                "scanner_collect_date",
                                            },
                                          },
                                          "text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.formData.collectDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "collectDate", $$v)
                              },
                              expression: "formData.collectDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("month-field", {
                            attrs: {
                              label: _vm.$t("dialog.month_label"),
                              rules: _vm.validationRules.monthLabel,
                              required: "",
                              "data-testid": "scanner_month_label",
                            },
                            model: {
                              value: _vm.formData.monthLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "monthLabel", $$v)
                              },
                              expression: "formData.monthLabel",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "drop-zone",
                      class: { "drag-over": _vm.isDragOver },
                      attrs: { "data-testid": "scanner_drop_zone" },
                      on: {
                        drop: _vm.onDrop,
                        dragover: function ($event) {
                          $event.preventDefault()
                          return _vm.onDragOver.apply(null, arguments)
                        },
                        dragleave: _vm.onDragLeave,
                        click: _vm.openFileSelector,
                      },
                    },
                    [
                      _c("v-icon", { attrs: { size: "48", color: "grey" } }, [
                        _vm._v("mdi-camera-plus"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "mt-2 mb-0 d-flex justify-center align-baseline",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dialog.select_images")) +
                              "\n            "
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "400" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "info-icon ml-1",
                                              attrs: {
                                                small: "",
                                                "aria-label": _vm.$t(
                                                  "dialog.image_spec_label"
                                                ),
                                              },
                                            },
                                            "v-icon",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                  mdi-information-outline\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("div", [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("dialog.image_spec_intro"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "mb-1 font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dialog.image_spec_resolution_title"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dialog.image_spec_resolution_desc"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "mb-1 font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dialog.image_spec_size_title")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dialog.image_spec_size_desc")
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("dialog.drag_drop_hint"))),
                      ]),
                      _vm._v(" "),
                      _vm.warningMessage
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-4 text-left text-body-2",
                              attrs: {
                                type: "warning",
                                outlined: "",
                                dense: "",
                                "data-testid": "scanner_warning",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.warningMessage) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-4 text-left text-body-2",
                              attrs: {
                                type: "error",
                                dense: "",
                                "data-testid": "scanner_error",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("input", {
                        ref: "fileInput",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          accept: ".jpg,.jpeg",
                          multiple: "",
                          "data-testid": "scanner-file-input",
                        },
                        on: { change: _vm.onFileInputChange },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedFiles.length > 0
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("dialog.selected_images"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              staticClass: "selected-files-list",
                              attrs: { dense: "" },
                            },
                            _vm._l(_vm.selectedFiles, function (file, index) {
                              return _c(
                                "v-list-item",
                                {
                                  key: index,
                                  staticClass: "selected-file-item",
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("mdi-file-image")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "text-truncate" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(file.name) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            "data-testid":
                                              "scanner_remove_file",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeFile(index)
                                            },
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("mdi-delete")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeDialog } },
                [_vm._v(_vm._s(_vm.$t("dialog.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    loading: _vm.uploading,
                    disabled: !_vm.isFormValid,
                    "data-testid": "scanner_submit",
                  },
                  on: { click: _vm.uploadImages },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("dialog.upload")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }